import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CHALLANS,
  GET_CHALLAN_DETAILS,
  CREATE_CHALLAN,
  UPDATE_CHALLAN,
  CHECK_CHALLAN_NUMBER,
} from "./actionTypes"
import {
  getChallansFail,
  getChallansSuccess,
  getChallanDetailsSuccess,
  getChallanDetailsFail,
  createChallanFail,
  createChallanSuccess,
  updateChallanSuccess,
  updateChallanFail,
  checkChallanNumberSuccess,
  checkChallanNumberFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Challan - This line cannot be edited or removed
function getChallansAPi({ page, limit, searchText, sort, sortByDate }) {
  return get(
    `/challan/admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText ? searchText : ""}&status=${
      sort !== "all" ? sort : ""
    }&from=${sortByDate.from ? sortByDate?.from : ""}&to=${
      sortByDate.to ? sortByDate?.to : ""
    }`
  )
}

const getChallanDetailsAPi = challanId => {
  return get(`/challan/${challanId}`)
}

const createChallanApi = ({ challan }) => {
  return post("/challan/admin/new", challan)
}

const updateChallanApi = ({ challan, challanId }) => {
  return ApiPut(`/challan/admin/${challanId}`, challan)
}

const deleteChallanApi = ({ challanId }) => {
  return del(`/challan/admin/${challanId}`)
}

const checkChallanNumberApi = ({ challanNumber, challanId }) => {
  if (challanId) {
    return post(`/challan/check/name/${challanId}`, challanNumber)
  } else {
    return post(`/challan/check/name`, challanNumber)
  }
}

function* fetchChallans({ payload }) {
  try {
    const response = yield call(getChallansAPi, payload)
    yield put(getChallansSuccess(response))
  } catch (error) {
    yield put(getChallansFail(error))
  }
}

function* fetchChallanDetails({ payload: challanId }) {
  try {
    const response = yield call(getChallanDetailsAPi, challanId)
    yield put(getChallanDetailsSuccess(response))
  } catch (error) {
    yield put(getChallanDetailsFail(error))
  }
}

function* onCreateChallan({ payload }) {
  try {
    const response = yield call(createChallanApi, payload)
    if (response?.message) {
      Notification({
        type: "error",
        message: response?.message,
        title: "",
      })
    } else if (response) {
      yield put(createChallanSuccess(response))
      payload?.history?.push("/challan/all")
      doneNotification("Challan Created Successfully!")
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createChallanFail(error))
  }
}

function* onUpdateChallan({ payload }) {
  try {
    const response = yield call(updateChallanApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Challan Updated Successfully!",
        title: "",
      })
      yield put(updateChallanSuccess(response))
      if (payload.history) {
        payload.history.goBack()
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateChallanFail(error.response.data))
  }
}

function* onCheckChallanNumber({ payload }) {
  try {
    const response = yield call(checkChallanNumberApi, payload)
    yield put(checkChallanNumberSuccess(response))
  } catch (error) {
    yield put(checkChallanNumberFail(error))
  }
}

function* ChallanSaga() {
  yield takeEvery(GET_CHALLANS, fetchChallans)
  yield takeEvery(GET_CHALLAN_DETAILS, fetchChallanDetails)
  yield takeEvery(CREATE_CHALLAN, onCreateChallan)
  yield takeEvery(UPDATE_CHALLAN, onUpdateChallan)
  yield takeEvery(CHECK_CHALLAN_NUMBER, onCheckChallanNumber)
}

export default ChallanSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
